import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getTotalVoted } from '../services/ResultsService';
import Counter from './Counter';
import Section from './Section';
import Loading from './Loading';

export default function CounterTotalSection({ totalKey, title }) {
  const { t } = useTranslation();
  const [total, setTotal] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getTotalVoted().then(
      (_totalVoted) => {
        setTotal(_totalVoted);
        setLoaded(true);
      },
    );
  }, []);

  return (
    <Section
      align="center"
      background="gray"
      title={title}
      content={(
        <>
          {loaded ? (
            <Counter
              title={t('voted_poll')}
              total={total[totalKey] || 0}
            />
          ) : <Loading />}
        </>
      )}
    />
  );
}

CounterTotalSection.defaultProps = {
  title: '',
};

CounterTotalSection.propTypes = {
  title: PropTypes.string,
  totalKey: PropTypes.oneOf(['TotalVotedForConsitutionInBY', 'TotalVoted', 'TotalVotedForConsitutionInBY', 'TotalWalking', 'CrowdActionsVoters']).isRequired,
};
